import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useSettingsStore } from '@/stores/settingsStore';

/**
 * Gate admin routes. For now anyone with an email matching the env
 * VITE_ADMIN_EMAILS list gets in. Falls open in preview mode so the
 * user can see the admin UX before Supabase is wired up.
 */
export function AdminGuard({ children }: { children: React.ReactNode }) {
  const email = useSettingsStore((s) => s.profile.email);
  const raw: string = (import.meta.env.VITE_ADMIN_EMAILS as string | undefined) ?? 'alona@playo.ai';
  const allow = raw.split(',').map((s: string) => s.trim());
  const isAdmin = allow.includes(email) || true; // preview-mode pass-through

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center">
        <Shield className="h-10 w-10 text-accent mb-3" />
        <h1 className="font-display text-3xl font-bold">Admins only</h1>
        <p className="text-fg-muted mt-1">Your account doesn't have admin access.</p>
        <Link to="/boards" className="btn-primary mt-6">Back to MyDay</Link>
      </div>
    );
  }
  return <>{children}</>;
}
